import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  root: {
    '& fieldset': {
      borderColor: 'white',
    },
    '&:hover fieldset': {
      borderColor: 'white',
    },
    '& .Mui-disabled': {
      borderRadius: "8px !important",
      borderColor: "#dfdfdf",
      backgroundColor: '#efefef !important',
      color: "#9e9e9e"
    },
  },
  currencyText: {
    width: '30px',
    color: '#303d8f',
    fontSize: 10,
    background: '#efefef',
    textAlign: 'center',
    borderRadius: 4,
    padding:'3px 0px',
  },
  label: {
    width: '100%',
    fontSize: '13px',
    color: '#455a64',
    marginBottom: '12px',
    position: 'relative',
    top: '6px',
    '&.MuiInputLabel': {
      marginTop: '6px',
      '&-shrink': {
        transform: 'translate(0, 1.5px) scale(1)',
      },
    },
  },
  asterisk: {
    color: '#ef5350',
  },
  currencyInput: {
    borderRadius: (props) => {
      const rightRadius = props.removeRightRadius;
      const leftRadius = props.removeLeftRadius;
      return `${leftRadius ? 0 : 8}px ${rightRadius ? 0 : 8}px ${rightRadius ? 0 : 8}px ${leftRadius ? 0 : 8
        }px`;
    },
    marginLeft: 0,
    width: '100%',
    marginRight: 0,
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: (props) => {
        const rightRadius = props.removeRightRadius;
        const leftRadius = props.removeLeftRadius;
        return `${leftRadius ? 0 : 8}px ${rightRadius ? 0 : 8}px ${rightRadius ? 0 : 8}px ${leftRadius ? 0 : 8
          }px`;
      },
    },
    '& .Mui-focused': {
      "& .MuiInputBase-input": {
        boxShadow: "none",
       
      }
    },
    direction: 'rtl',
    '& input': {
      marginLeft: 0,
      marginRight: 0,
      height: 18,
      position: 'relative',
      fontFamily: 'Vazir FD',
      padding: '11px 7px',
      fontSize: 14,
      transition: "all .1s ease-in",
      outline: "none",
      direction: 'rtl',
      '&::placeholder': {
        direction: 'ltr',
        textAlign: 'left',
      },
    },
  },
  bootstrapInput: {
    '&.Mui-focused': {
      "& .MuiInputBase-input": {
        backgroundColor: "#fff",
        borderColor: '#2B3990 !important',
        
      },
     
     
    },
  },
  maskInput: {
    borderRadius: (props) => {
      const rightRadius = props.removeRightRadius;
      const leftRadius = props.removeLeftRadius;
      return `${leftRadius ? 0 : 8}px ${rightRadius ? 0 : 8}px ${rightRadius ? 0 : 8}px ${leftRadius ? 0 : 8
        }px`;
    },
    height: 38.63,
    position: 'relative',
    fontFamily: 'Vazir',
    padding: '10px 12px',
    direction: 'rtl',
    border: '1px solid #dfdfdf',
    // backgroundColor: "#F6F7F8",
    transition: "all .1s ease-in",
    '&::placeholder': {
      direction: 'ltr',
      textAlign: 'left',
    },
    '&:focus': {
      outline: 'none',
      backgroundColor: "#fff",
      borderColor: '#2B3990 !important',
      // boxShadow: "0px 0px 0px 1px #fff, 0px 0px 0px 4px #c3dbf3 !important",
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #b0bec5 !important',
      borderRadius: (props) => {
        const rightRadius = props.removeRightRadius;
        const leftRadius = props.removeLeftRadius;
        return `${leftRadius ? 0 : 4}px ${rightRadius ? 0 : 4}px ${rightRadius ? 0 : 4}px ${leftRadius ? 0 : 4
          }px`;
      },
    },
  },
  error: {},
}));
